
import React, { useMemo } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { Users } from 'lucide-react';

const SegmentDemographics = ({ segmentId, demographicsData = [] }) => {
  // Ensure we have valid data or fallback to defaults
  const safeData = useMemo(() => {
    if (!Array.isArray(demographicsData) || demographicsData.length === 0) {
      return [
        { name: 'Local Residential', value: 30 },
        { name: 'Commercial', value: 45 },
        { name: 'Commuters', value: 25 }
      ];
    }
    return demographicsData;
  }, [demographicsData]);
  
  // Colors for the pie chart segments
  const COLORS = useMemo(() => {
    const colorMap = {
      'urban': ['#8B5CF6', '#A78BFA', '#C4B5FD', '#DDD6FE'],
      'highway': ['#3B82F6', '#60A5FA', '#93C5FD', '#BFDBFE'],
      'rural': ['#10B981', '#34D399', '#6EE7B7', '#A7F3D0'],
      'suburban': ['#F59E0B', '#FBBF24', '#FCD34D', '#FDE68A']
    };
    
    return colorMap[segmentId] || colorMap.urban;
  }, [segmentId]);

  return (
    <div className="bg-white rounded-lg shadow mb-6">
      <div className="border-b border-gray-200 p-4">
        <div className="flex items-center text-lg font-medium text-gray-900">
          <Users size={20} className="mr-2 text-purple-600" />
          Customer Demographics
        </div>
      </div>
      
      <div className="p-4">
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={safeData}
                cx="50%"
                cy="50%"
                labelLine={true}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
              >
                {safeData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip formatter={(value) => `${value}%`} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default SegmentDemographics;
